export enum EFinalidadeProdutos {
    Revenda = 1,
    ConsumoProprio = 2,
    AmbosRevendaRevendaConsumo = 3,
}
